import style from './Scroll.style';

export default function Scroll({ children }) {
  return (
    <section css={ style }>
      { children }
    </section>
  );
};